import { decorate, observable } from "mobx";

class MapStore {
  brandId = null;
  categoryId = null;
  stateId = null;
  dmaId = null;
  lastHighlightedDMAFeature = null;
  lastHighlightedStateFeature = null;
  showLoader = true;
  tenantId = null;
  locationGroupId = null;

  geo = {
    geoId: null,
    geoType: null,
    lat: null,
    lon: null,
  };

  stateDistribution = {
    requestId: null,
    geos: [],
  };

  dmaDistribution = {
    requestId: null,
    geos: [],
  };

  mapPadding = {
    left: null,
    right: null,
    top: null,
    bottom: null,
  };
}

decorate(MapStore, {
  brandId: observable,
  categoryId: observable,
  geo: observable,
  stateId: observable,
  dmaId: observable,
  showLoader: observable,
  lastHighlightedDMAFeature: observable,
  lastHighlightedStateFeature: observable,
  stateDistribution: observable,
  dmaDistribution: observable,
  mapPadding: observable,
});
export default MapStore;
